var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $gvars = Opal.gvars, $truthy = Opal.truthy, $send = Opal.send;

  Opal.add_stubs(['$setPrefixes', '$===', '$getRollResult', '$getMedResult', '$getResResult', '$getInnyouResult', '$getHattokuResult', '$getGogyouResult', '$=~', '$to_i', '$roll', '$getCheckResult', '$getDiceListFromText', '$isFamble', '$isCritical', '$<=', '$sort', '$collect', '$split', '$getTargetFromValue', '$+', '$-', '$getResistCheckResult', '$getResultRank', '$>', '$<', '$index', '$times', '$==', '$%', '$<<', '$getOddEven', '$join', '$getGogyouTable', '$get_table_by_1d6']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'HouraiGakuen');

    var $nesting = [self].concat($parent_nesting), $HouraiGakuen_gameName$1, $HouraiGakuen_gameType$2, $HouraiGakuen_getHelpMessage$3, $HouraiGakuen_rollDiceCommand$4, $HouraiGakuen_getRollResult$5, $HouraiGakuen_getCheckResult$6, $HouraiGakuen_getDiceListFromText$7, $HouraiGakuen_isFamble$9, $HouraiGakuen_isCritical$10, $HouraiGakuen_getMedResult$11, $HouraiGakuen_getTargetFromValue$12, $HouraiGakuen_getResResult$13, $HouraiGakuen_getResistCheckResult$14, $HouraiGakuen_getResultRank$15, $HouraiGakuen_getInnyouResult$16, $HouraiGakuen_getHattokuResult$18, $HouraiGakuen_getOddEven$20, $HouraiGakuen_getGogyouResult$21, $HouraiGakuen_getGogyouTable$22;

    
    self.$setPrefixes(["ROL.*", "MED\\(\\d+,\\d+\\)", "RES\\(\\d+,\\d+\\)", "INY.*", "HTK.*", "GOG.*"]);
    
    Opal.def(self, '$gameName', $HouraiGakuen_gameName$1 = function $$gameName() {
      var self = this;

      return "蓬莱学園の冒険!!"
    }, $HouraiGakuen_gameName$1.$$arity = 0);
    
    Opal.def(self, '$gameType', $HouraiGakuen_gameType$2 = function $$gameType() {
      var self = this;

      return "HouraiGakuen"
    }, $HouraiGakuen_gameType$2.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $HouraiGakuen_getHelpMessage$3 = function $$getHelpMessage() {
      var self = this;

      return "" + "・基本ロール：ROL(x+n)\n" + "  ROLL(自分の能力値 + 簡単値 + 応石 or 蓬莱パワー)と記述します。3D6をロールし、成功したかどうかを表示します。\n" + "  例）ROL(4+6)\n" + "・対人判定：MED(x,y)\n" + "  自分の能力値 x と 相手の能力値 y でロールを行い、成功したかどうかを表示します。\n" + "  例）MED(5,2)\n" + "・対抗判定：RES(x,y)\n" + "  自分の能力値 x と 相手の能力値 y で相互にロールし、どちらが成功したかを表示します。両者とも成功 or 失敗の場合は引き分けとなります。\n" + "  例）RES(6,4)\n" + "・陰陽コマンド INY\n" + "  例）Hourai : 陽（奇数の方が多い）\n" + "・五行コマンド：GOG\n" + "  例）Hourai : 五行表(3) → 五行【土】\n" + "・八徳コマンド：HTK\n" + "  例）Hourai : 仁義八徳は、【義】(奇数、奇数、偶数)\n"
    }, $HouraiGakuen_getHelpMessage$3.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $HouraiGakuen_rollDiceCommand$4 = function $$rollDiceCommand(command) {
      var $a, self = this, $case = nil, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
      $case = command;
      if (/^ROL/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getRollResult(command);}
      else if (/^MED/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getMedResult(command);}
      else if (/^RES/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getResResult(command);}
      else if (/^INY/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getInnyouResult(command);}
      else if (/^HTK/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getHattokuResult(command);}
      else if (/^GOG$/i['$===']($case)) {
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      return self.$getGogyouResult(command);};
      return nil;
    }, $HouraiGakuen_rollDiceCommand$4.$$arity = 1);
    (Opal.class_variable_set($nesting[0], '@@critical', "大成功"));
    (Opal.class_variable_set($nesting[0], '@@success', "成功"));
    (Opal.class_variable_set($nesting[0], '@@failure', "失敗"));
    (Opal.class_variable_set($nesting[0], '@@famble', "大失敗"));
    
    Opal.def(self, '$getRollResult', $HouraiGakuen_getRollResult$5 = function $$getRollResult(command) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, target = nil, total = nil, diceText = nil, result = nil;

      
      if ($truthy(/rol([-\d]+)/i['$=~'](command))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      target = __last__match__1.$to_i();
      $b = self.$roll(3, 6), $a = Opal.to_ary($b), (total = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      result = self.$getCheckResult(diceText, total, target);
      return "" + "(3d6<=" + (target) + ") ＞ 出目" + (diceText) + "＝合計" + (total) + " ＞ " + (result);
    }, $HouraiGakuen_getRollResult$5.$$arity = 1);
    
    Opal.def(self, '$getCheckResult', $HouraiGakuen_getCheckResult$6 = function $$getCheckResult(diceText, total, target) {
      var $a, self = this, diceList = nil;

      
      diceList = self.$getDiceListFromText(diceText);
      if ($truthy(self.$isFamble(diceList))) {
        return (($a = $nesting[0].$$cvars['@@famble']) == null ? nil : $a)};
      if ($truthy(self.$isCritical(diceList))) {
        return (($a = $nesting[0].$$cvars['@@critical']) == null ? nil : $a)};
      if ($truthy($rb_le(total, target))) {
        return (($a = $nesting[0].$$cvars['@@success']) == null ? nil : $a)};
      return (($a = $nesting[0].$$cvars['@@failure']) == null ? nil : $a);
    }, $HouraiGakuen_getCheckResult$6.$$arity = 3);
    
    Opal.def(self, '$getDiceListFromText', $HouraiGakuen_getDiceListFromText$7 = function $$getDiceListFromText(diceText) {
      var $$8, self = this, diceList = nil;

      
      diceList = $send(diceText.$split(/,/), 'collect', [], ($$8 = function(i){var self = $$8.$$s || this;

      
        
        if (i == null) {
          i = nil;
        };
        return i.$to_i();}, $$8.$$s = self, $$8.$$arity = 1, $$8)).$sort();
      return diceList;
    }, $HouraiGakuen_getDiceListFromText$7.$$arity = 1);
    
    Opal.def(self, '$isFamble', $HouraiGakuen_isFamble$9 = function $$isFamble(diceList) {
      var self = this;

      return diceList['$===']([6, 6, 6])
    }, $HouraiGakuen_isFamble$9.$$arity = 1);
    
    Opal.def(self, '$isCritical', $HouraiGakuen_isCritical$10 = function $$isCritical(diceList) {
      var self = this;

      return diceList['$===']([1, 2, 3])
    }, $HouraiGakuen_isCritical$10.$$arity = 1);
    
    Opal.def(self, '$getMedResult', $HouraiGakuen_getMedResult$11 = function $$getMedResult(command) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, yourValue = nil, enemyValue = nil, target = nil, total = nil, diceText = nil, result = nil;

      
      if ($truthy(/med\((\d+),(\d+)\)/i['$=~'](command))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      yourValue = __last__match__1.$to_i();
      enemyValue = __last__match__2.$to_i();
      target = self.$getTargetFromValue(yourValue, enemyValue);
      $b = self.$roll(3, 6), $a = Opal.to_ary($b), (total = ($a[0] == null ? nil : $a[0])), (diceText = ($a[1] == null ? nil : $a[1])), $b;
      result = self.$getCheckResult(diceText, total, target);
      return "" + "(あなたの値" + (yourValue) + "、相手の値" + (enemyValue) + "、3d6<=" + (target) + ") ＞ 出目" + (diceText) + "＝合計" + (total) + " ＞ " + (result);
    }, $HouraiGakuen_getMedResult$11.$$arity = 1);
    
    Opal.def(self, '$getTargetFromValue', $HouraiGakuen_getTargetFromValue$12 = function $$getTargetFromValue(yourValue, enemyValue) {
      var self = this;

      return $rb_plus(yourValue, $rb_minus(10, enemyValue))
    }, $HouraiGakuen_getTargetFromValue$12.$$arity = 2);
    
    Opal.def(self, '$getResResult', $HouraiGakuen_getResResult$13 = function $$getResResult(command) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, yourValue = nil, enemyValue = nil, yourTarget = nil, enemyTarget = nil, yourTotal = nil, yourDiceText = nil, enemyTotal = nil, enemyDiceText = nil, yourResult = nil, enemyResult = nil, result = nil;

      
      if ($truthy(/res\((\d+),(\d+)\)/i['$=~'](command))) {
      } else {
        return nil
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      yourValue = __last__match__1.$to_i();
      enemyValue = __last__match__2.$to_i();
      yourTarget = self.$getTargetFromValue(yourValue, enemyValue);
      enemyTarget = self.$getTargetFromValue(enemyValue, yourValue);
      $b = self.$roll(3, 6), $a = Opal.to_ary($b), (yourTotal = ($a[0] == null ? nil : $a[0])), (yourDiceText = ($a[1] == null ? nil : $a[1])), $b;
      $b = self.$roll(3, 6), $a = Opal.to_ary($b), (enemyTotal = ($a[0] == null ? nil : $a[0])), (enemyDiceText = ($a[1] == null ? nil : $a[1])), $b;
      yourResult = self.$getCheckResult(yourDiceText, yourTotal, yourTarget);
      enemyResult = self.$getCheckResult(enemyDiceText, enemyTotal, enemyTarget);
      result = self.$getResistCheckResult(yourResult, enemyResult);
      return "" + "あなたの値" + (yourValue) + "、相手の値" + (enemyValue) + "\n" + "(あなたのロール 3d6<=" + (yourTarget) + ") ＞ " + (yourDiceText) + "=" + (yourTotal) + " ＞ " + (yourResult) + "\n" + "(相手のロール 3d6<=" + (enemyTarget) + ") ＞ " + (enemyDiceText) + "=" + (enemyTotal) + " ＞ " + (enemyResult) + "\n" + "＞" + (result);
    }, $HouraiGakuen_getResResult$13.$$arity = 1);
    
    Opal.def(self, '$getResistCheckResult', $HouraiGakuen_getResistCheckResult$14 = function $$getResistCheckResult(yourResult, enemyResult) {
      var self = this, yourRank = nil, enemyRank = nil;

      
      yourRank = self.$getResultRank(yourResult);
      enemyRank = self.$getResultRank(enemyResult);
      if ($truthy($rb_gt(yourRank, enemyRank))) {
        return "あなたが勝利"};
      if ($truthy($rb_lt(yourRank, enemyRank))) {
        return "相手が勝利"};
      return "引き分け";
    }, $HouraiGakuen_getResistCheckResult$14.$$arity = 2);
    
    Opal.def(self, '$getResultRank', $HouraiGakuen_getResultRank$15 = function $$getResultRank(result) {
      var $a, self = this, ranks = nil;

      
      ranks = [(($a = $nesting[0].$$cvars['@@famble']) == null ? nil : $a), (($a = $nesting[0].$$cvars['@@failure']) == null ? nil : $a), (($a = $nesting[0].$$cvars['@@success']) == null ? nil : $a), (($a = $nesting[0].$$cvars['@@critical']) == null ? nil : $a)];
      return ranks.$index(result);
    }, $HouraiGakuen_getResultRank$15.$$arity = 1);
    
    Opal.def(self, '$getInnyouResult', $HouraiGakuen_getInnyouResult$16 = function $$getInnyouResult(command) {
      var $$17, self = this, oddCount = nil, evenCount = nil;

      
      oddCount = 0;
      evenCount = 0;
      $send((3), 'times', [], ($$17 = function(){var self = $$17.$$s || this, $a, $b, dice = nil;

      
        $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), $b;
        if (dice['$%'](2)['$=='](0)) {
          return (evenCount = $rb_plus(evenCount, 1))
        } else {
          return (oddCount = $rb_plus(oddCount, 1))
        };}, $$17.$$s = self, $$17.$$arity = 0, $$17));
      if ($truthy($rb_lt(evenCount, oddCount))) {
        return "陽（奇数の方が多い）"
      } else {
        return "陰（偶数の方が多い）"
      };
    }, $HouraiGakuen_getInnyouResult$16.$$arity = 1);
    
    Opal.def(self, '$getHattokuResult', $HouraiGakuen_getHattokuResult$18 = function $$getHattokuResult(command) {
      var $$19, self = this, oddEvenList = nil, oddEvenText = nil, $case = nil;

      
      oddEvenList = [];
      $send((3), 'times', [], ($$19 = function(){var self = $$19.$$s || this;

      return oddEvenList['$<<'](self.$getOddEven())}, $$19.$$s = self, $$19.$$arity = 0, $$19));
      oddEvenText = oddEvenList.$join("、");
      return (function() {$case = oddEvenText;
      if ("奇数、奇数、奇数"['$===']($case)) {return "" + "仁義八徳は、【仁】(" + (oddEvenText) + ")"}
      else if ("奇数、奇数、偶数"['$===']($case)) {return "" + "仁義八徳は、【義】(" + (oddEvenText) + ")"}
      else if ("奇数、偶数、奇数"['$===']($case)) {return "" + "仁義八徳は、【礼】(" + (oddEvenText) + ")"}
      else if ("奇数、偶数、偶数"['$===']($case)) {return "" + "仁義八徳は、【智】(" + (oddEvenText) + ")"}
      else if ("偶数、奇数、奇数"['$===']($case)) {return "" + "仁義八徳は、【忠】(" + (oddEvenText) + ")"}
      else if ("偶数、奇数、偶数"['$===']($case)) {return "" + "仁義八徳は、【信】(" + (oddEvenText) + ")"}
      else if ("偶数、偶数、奇数"['$===']($case)) {return "" + "仁義八徳は、【孝】(" + (oddEvenText) + ")"}
      else if ("偶数、偶数、偶数"['$===']($case)) {return "" + "仁義八徳は、【悌】(" + (oddEvenText) + ")"}
      else {return "異常終了"}})();
    }, $HouraiGakuen_getHattokuResult$18.$$arity = 1);
    
    Opal.def(self, '$getOddEven', $HouraiGakuen_getOddEven$20 = function $$getOddEven() {
      var $a, $b, self = this, dice = nil;

      
      $b = self.$roll(1, 6), $a = Opal.to_ary($b), (dice = ($a[0] == null ? nil : $a[0])), $b;
      if (dice['$%'](2)['$=='](0)) {
        return "偶数"};
      return "奇数";
    }, $HouraiGakuen_getOddEven$20.$$arity = 0);
    
    Opal.def(self, '$getGogyouResult', $HouraiGakuen_getGogyouResult$21 = function $$getGogyouResult(command) {
      var $a, $b, self = this, type = nil, table = nil, text = nil, number = nil, output = nil;

      
      type = "五行表";
      table = self.$getGogyouTable();
      $b = self.$get_table_by_1d6(table), $a = Opal.to_ary($b), (text = ($a[0] == null ? nil : $a[0])), (number = ($a[1] == null ? nil : $a[1])), $b;
      output = "" + (type) + "(" + (number) + ") ＞ " + (text);
      return output;
    }, $HouraiGakuen_getGogyouResult$21.$$arity = 1);
    return (Opal.def(self, '$getGogyouTable', $HouraiGakuen_getGogyouTable$22 = function $$getGogyouTable() {
      var self = this, table = nil;

      
      table = ["五行【木】", "五行【火】", "五行【土】", "五行【金】", "五行【水】", "五行は【任意選択】"];
      return table;
    }, $HouraiGakuen_getGogyouTable$22.$$arity = 0), nil) && 'getGogyouTable';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
